export default "__VITE_ASSET__BkhB_EZz__"